import { getDevice } from './openpoint'

export function alertMsg(message, gid) {
    if(gid === 'GID00000000000000') {
        console.log(message + ' (' + (new Date())+ ',' + getDevice() +  ')')
    }
}
